import React from 'react';
import { Box, Icon, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './TrimOverview.styles';
const TrimCarouselToastContainer = themeStyles.apply(Box, 'TrimCarouselToastContainer');
const TrimCarouselToast = themeStyles.apply(Box, 'TrimCarouselToast');
const TrimCarouselToastIcon = themeStyles.apply(Icon, 'TrimCarouselToastIcon');
const ImageComingSoon = () => {
    const { t } = useTranslation();
    return (React.createElement(TrimCarouselToastContainer, { "data-testid": "cy-trim-carousel-toast-container" },
        React.createElement(TrimCarouselToast, null,
            React.createElement(TrimCarouselToastIcon, { name: "information", color: "white", filled: true }),
            React.createElement(Copy, { color: "inherit", size: "extraSmall" }, t('Pages.Bap.imageComingSoonLabel')))));
};
export default ImageComingSoon;
